import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Skeleton, Typography } from '@mui/material';
import { times } from 'lodash';
import React, { useState } from 'react';
import { Button, Modal } from '../../../components';
import { UsersLockedErrorType } from '../../../services/Users/types';
import {
  useDispatch,
  useSelector,
  userSlice,
  fetchUserCancel,
  fetchUsersList,
} from '../../../stores';
import {
  StyledModalInnerWrapper,
  StyledModalTextRow,
  StyledModalWrapper,
} from '../styles';

export const CancelUserModal: React.FC = () => {
  const dispatch = useDispatch();

  const { userInfo, userInfoLoading, userCancelIsOpen, userCancelLoading } = useSelector((state) => state.userReducer);
  const filtersValues = useSelector((state) => state.usersFiltersValuesReducer);

  const [lockedModalOpen, setLockedModalOpen] = useState(false);
  const [lockedModalMessage, setLockedModalMessage] = useState('');

  const handleClose = () => {
    dispatch(userSlice.actions.toggleUserCancelIsOpen());
    dispatch(userSlice.actions.resetUserCancelLoading());
  };

  const handleSubmit = () => {
    if (userInfo) {
      dispatch(fetchUserCancel({ userId: userInfo.id.toString() }))
        .then((result) => {
          const payload = result.payload as UsersLockedErrorType;

          if (payload?.status == 423) {
            handleClose();
            setLockedModalMessage(payload.msg);
            setLockedModalOpen(true);

            return;
          }

          handleClose();
          dispatch(fetchUsersList(filtersValues));
        });
    }
  };

  const handleReturn = () => {
    dispatch(userSlice.actions.toggleUserCancelIsOpen());
    dispatch(userSlice.actions.resetUserCancelLoading());
  };

  return (
    <>
      <Modal
        open={userCancelIsOpen}
        onClose={handleClose}
        title='Deseja excluir esse usuário?'
      >
        <>
          {userInfoLoading ? (
            <StyledModalWrapper>
              <StyledModalInnerWrapper>
                {times(3, () => (
                  <Skeleton animation='wave' height={29} width='100%' />
                ))}
              </StyledModalInnerWrapper>
            </StyledModalWrapper>
          ) : (
            <StyledModalWrapper>
              <StyledModalInnerWrapper>
                <StyledModalTextRow>
                  <Typography color='primary' sx={{ fontWeight: 'bold' }}>
                    Nome:
                  </Typography>
                  <Typography>{userInfo?.name}</Typography>
                </StyledModalTextRow>
                {/* <StyledModalTextRow>
                  <Typography color='primary' sx={{ fontWeight: 'bold' }}>
                    Descrição:
                  </Typography>
                  <Typography>{userInfo?.description || '--'}</Typography>
                </StyledModalTextRow>
                <StyledModalTextRow>
                  <Typography color='primary' sx={{ fontWeight: 'bold' }}>
                    Cor:
                  </Typography>
                  <Typography>{userInfo?.color}</Typography>
                </StyledModalTextRow> */}
              </StyledModalInnerWrapper>
            </StyledModalWrapper>
          )}
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              mt: '10px',
            }}
          >
            <Button
              variant='contained'
              color='error'
              label='Excluir'
              startIcon={<DeleteIcon />}
              type='submit'
              style={{ width: '100%', margin: 0, marginTop: 30 }}
              loading={userCancelLoading}
              onClick={handleSubmit}
            />
            <Button
              color='error'
              variant='contained'
              type='reset'
              startIcon={<ArrowBackIcon />}
              label='Voltar'
              style={{ width: '100%', margin: 0, marginTop: 10 }}
              onClick={handleReturn}
            />
          </Box>
        </>
      </Modal>
      <Modal
        open={lockedModalOpen}
        onClose={() => {
          setLockedModalOpen(false);
          setLockedModalMessage('');
        }}
        title='Erro'
      >
        <Box>
          <Typography>{lockedModalMessage}</Typography>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              mt: '10px',
            }}
          >
            <Button
              color='secondary'
              variant='contained'
              label='Continuar'
              style={{ width: '100%', margin: 0, marginTop: 10 }}
              onClick={() => {
                setLockedModalOpen(false);
                setLockedModalMessage('');
              }}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};